export function setHeaders() {
  
    if (localStorage.getItem("token")) {
        return {
            Authorization:"Token " + localStorage.getItem("token"),
            // 'Content-Type': 'application/json',
            // Accept: 'text/plain',
        };
    } else {
        return {
            'Content-Type': 'application/json',
            // Accept: 'text/plain',
        };
    }

}